const productionOrigin = 'https://christinajbarea.com';

const metadata: Record<string, { title: string; description: string }> = {
  '/': { title: 'Christina J Barea | Speaker', description: 'Christina J Barea brings ancient intelligence and modern wellbeing to keynotes, workshops, and corporate programs.' },
  '/about': { title: 'About | Christina J Barea', description: 'Meet medical Qigong clinician, author, teacher, and speaker Christina J Barea.' },
  '/speaking': { title: 'Speaking | Christina J Barea', description: 'Explore Christina J Barea’s signature talks, workshops, and audience outcomes.' },
  '/engagements': { title: 'Engagements | Christina J Barea', description: 'Upcoming and past speaking engagements with Christina J Barea.' },
  '/books-media': { title: 'Books & Media | Christina J Barea', description: 'Books, television, and media work from Christina J Barea.' },
  '/contact': { title: 'Book Christina | Christina J Barea', description: 'Request Christina J Barea for a keynote, workshop, panel, or corporate program.' }
};

export function metadataForPath(pathname: string) {
  const path = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
  const selected = metadata[path] ?? { title: 'Christina J Barea | Speaker', description: 'Ancient intelligence and modern wellbeing for audiences ready to move forward.' };
  return { ...selected, canonicalUrl: `${productionOrigin}${path === '/' ? '/' : path}` };
}

function meta(name: string, content: string, property = false) {
  const attribute = property ? 'property' : 'name';
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
  if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
  element.content = content;
}

export function applyMetadata(pathname: string) {
  const selected = metadataForPath(pathname);
  document.title = selected.title;
  meta('description', selected.description);
  meta('og:title', selected.title, true); meta('og:description', selected.description, true); meta('og:url', selected.canonicalUrl, true);
  meta('twitter:card', 'summary_large_image'); meta('twitter:title', selected.title); meta('twitter:description', selected.description);
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
  canonical.href = selected.canonicalUrl;
}
